export function isAtLeast18YearsOld(dateOfBirth: string): boolean {
  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return false;
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age -= 1;
  }
  return age >= 18;
}

export function normalizeBsb(value: string): string {
  return value.replace(/\D/g, '').slice(0, 6);
}

export function normalizeAbn(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11);
}
